import { IFormJBPHPContactChangeRequest } from 'legacy/lut/classes/models/partner360/IFormHPContacts'

import { Nullable } from 'cng-common/models/utils'
import { NotificationController } from 'core-components/library/popup'
import { guid } from 'core/classes/helpers/GuidHelper'

import { getJbpHpContactsCrud } from '../lib'

import { getContactsByEmail } from './getContactsByEmail'
import { IHpContactRequest } from './types'

interface IParams {
  request: IFormJBPHPContactChangeRequest
}

export const createChangeRequest = async ({
  request,
}: IParams): Promise<Nullable<IHpContactRequest>> => {
  const crud = getJbpHpContactsCrud('welcome-flow-add-request')

  const isAddRequest = request.RequestAction === 'Add'
  if (isAddRequest) {
    const matches = await getContactsByEmail({
      partnerId: request.PartnerId,
      email: request.Email,
      isForce: true,
    })

    if (matches.length > 0) {
      NotificationController.showError({
        message: 'Such contact already exists',
      })

      return null
    }
  }

  request = {
    ...request,
    EntryId: -1,
    Status: request.TicketStatus,
    Action: request.RequestAction,
    SignId: request.SignId || `new-${guid()}`,
  }

  const response = await crud.create(
    { formId: '1217', code: 'jbp-hp-contact-change-request-1217' },
    [request]
  )

  return response[0] ?? null
}
